import isEmpty from 'lodash/isEmpty';
import Catalyst from '@Services/Catalyst';
import { getProjectRoutesTypeFromInfoMapForAA, getProjectDetail, RouteType } from '@Pages/RetroSynthesis/constants';

function _convertRouteForAA(projectId, route) {
  const { id, stepCount, routeType } = route || {};
  return {
    id: `project:${projectId}`,
    id2: `route:${id}`,
    format: 'route',
    type: routeType ? RouteType.trackingMap[routeType] : '', // 'predicted' or 'published'
    datapoints: `${stepCount}`, // e.g. '7', '0'. Leave empty if unknown
  };
}

function _getProjectRoutesContentForAA(projectId, routes, projectInfo) {
  const content = [
    {
      id: `project:${projectId}`, // e.g.’14384721'
      detail: getProjectDetail({ ...projectInfo, id: projectId }),
      type: getProjectRoutesTypeFromInfoMapForAA(projectInfo),
      format: 'project',
    },
  ];
  if (!isEmpty(routes)) {
    content.push(...routes.map((r) => _convertRouteForAA(projectId, r)));
  }
  return content;
}

export const onRoutesLoaded = (projectId, routes, projectInfo) => {
  Catalyst.trackEvent('newPage', {
    page: {
      name: 'retrosynthesis:project:view',
    },
    content: _getProjectRoutesContentForAA(projectId, routes, projectInfo),
  });
};

export const onRoutesChanged = (projectId, routes, projectInfo) => {
  Catalyst.trackEvent('contentWindowLoad', { content: _getProjectRoutesContentForAA(projectId, routes, projectInfo) });
};

export const onRoutesDelete = (projectId, routes, projectInfo) => {
  Catalyst.trackEvent('contentDeletion', {
    content: _getProjectRoutesContentForAA(projectId, routes, projectInfo),
  });
};

export const onRouteViewClick = (projectId, route, projectInfo) => {
  Catalyst.trackEvent('contentSelection', {
    content: _getProjectRoutesContentForAA(projectId, route, projectInfo),
  });
};
